<div class="modal-header">
	@if (showModalClose()) {
		<button class="close" (click)="modalRef.hide()">&times;</button>
	}
	<h4 class="modal-title">Add Company</h4>
</div>
<div class="modal-body">
	@if (errorMessage()) {
		<alert type="danger" class="mb-3 name-reservation-submit-error">{{ errorMessage() }}</alert>
	}

	@if (nameStepState() === 'capturingProposedNames') {
		<app-proposed-names-form
			[initialNames]="proposedNamesDraft()"
			(confirmed)="onProposedNamesConfirmed($event)"
			(cancelled)="onProposedNamesCancelled()"
		/>
	}

	<div [class.d-none]="nameStepState() === 'capturingProposedNames'">
		<app-component-loader [isLoading]="!transactionFound() && !errorMessage()">
			<app-stepper #stepper (stepChanged)="onRegistrationStep($event)">
				<app-step tag="notice">
					<div class="form-group note-groups">
						<label>Please note:</label>
						<p>
							We currently only support the registration of private companies with a standard Memorandum of Incorporation
							("MOI").
						</p>
						<a class="form-group" (click)="advanceRegistration()">
							<app-icon [icon]="faPlusIcon"/>
							Register Private Company with standard MOI
						</a>
					</div>
				</app-step>

				<app-step [formGroup]="nameReservationForm"
				          [stepControl]="nameReservationForm"
				          tag="nameReservation">
					<div class="subheading">Name Reservation</div>

					<div class="form-group required name-reservation-selection">
						<label class="control-label">Company Name</label>
						<select
							class="form-control"
							[class.placeholder]="!nameReservationForm.value.name_reservation_id"
							formControlName="name_reservation_id"
						>
							<option value="" disabled>Select Reserved Name</option>
							@for (option of nameReservationOptions(); track option.id) {
								<option [value]="option.id">{{ option.name }}</option>
							}
							<option [value]="0">+ Reserve New Company Name</option>
						</select>
					</div>

					@if (nameStepState() === 'reserveNew' && nameReservationForm.value.name_1) {
						<div class="form-group proposed-names-summary">
							<label class="control-label">Proposed Names</label>
							<p class="proposed-name-primary">
								{{ nameReservationForm.value.name_1 }}
								@if (nameReservationForm.value.name_2) {
									<span>, {{ nameReservationForm.value.name_2 }}</span>
								}
								@if (nameReservationForm.value.name_3) {
									<span>, {{ nameReservationForm.value.name_3 }}</span>
								}
								@if (nameReservationForm.value.name_4) {
									<span>, {{ nameReservationForm.value.name_4 }}</span>
								}
							</p>
							<a class="edit-proposed-names" (click)="openProposedNamesForm()">Edit proposed names</a>
						</div>
					}

					<p class="align-right"><span class="required">*</span> Indicates a required field</p>

					<div class="modal-footer">
						<app-submit-button
							submitLabel="Next"
							[isDisabled]="!nameReservationForm.valid"
							(clicked)="advanceRegistration()"
						/>
					</div>
				</app-step>

				<app-step [stepControls]="companyDetailsFormComponent.companyForms()"
				          tag="companyInformation">
					<app-portfolio-company-details-form #companyDetailsFormComponent/>

					<div class="modal-footer">
						<a class="btn-nav btn-prev" (click)="stepper.previous()"> Back </a>
						<app-submit-button submitLabel="Next" (clicked)="advanceRegistration()"/>
					</div>
				</app-step>

				<app-step [stepControls]="directorsInformationComponent.directorForms()"
									tag="directorInformation">
					<app-directors-information #directorsInformationComponent enforceUniqueEmail />

					<div class="modal-footer">
						<a class="btn-nav btn-prev" (click)="stepper.previous()"> Back </a>
						<app-submit-button submitLabel="Review" (clicked)="submitInformationToCipc()"/>
					</div>
				</app-step>

				<app-step tag="reviewInformation">
					@if (stepper.selectedTag() === 'reviewInformation') {
						<app-company-information-confirmation
							[companyDetails]="companyDetailsFormComponent.getCompanyDetails()"
							[directorsDetails]="directorsInformationComponent.getDirectorsDetails()"
						>
							<div class="form-group name-reservation-review">
								<label class="subheading d-block w-100">Name Reservation</label>
								<br/>
								<div class="d-flex justify-content-end align-items-center gap-1 mb-2 reserved-company-name">
								@if (isReserveNewSelected()) {
									1st Proposed Name: <strong>{{ nameReservationForm.value.name_1 }} (PTY) LTD</strong>
								} @else {
									Reserved Company Name: <strong>{{ nameReservationForm.value.name_1 }} (PTY) LTD</strong>
								}
							</div>
							</div>
						</app-company-information-confirmation>
					}

					<div class="modal-footer">
						<a class="btn-nav btn-prev" (click)="stepper.previous()"> Back </a>
						<app-submit-button submitLabel="Confirm" (clicked)="displayCheckout()"/>
					</div>
				</app-step>

				<app-step tag="checkout">
					@if (stepper.selectedTag() === 'checkout') {
						<app-checkout-form
							[checkoutItems]="items()"
							[companyId]="null"
							[cipcTypeId]="cipcTypeId"
							[cipcTransactionId]="cipcService.transaction.id"
							[showUpgradeSavings]="false"
							(transactionSuccess)="submitPayment($event)"
						/>
					}
				</app-step>

				<app-step tag="success">
					@if (transactionResponse()) {
						<div class="confirmation-dialog company-setup">
							<label class="control-label">Success!</label>
							<p class="form-group control-label" [innerHtml]="transactionResponse()!.message"></p>

							@if (transactionResponse()!.warning) {
								<p><span style="color: red">Warning:</span> {{ transactionResponse()!.warning?.message }}</p>
							}

							<a [href]="googleCalendarUrl" target="_blank" rel="noopener noreferrer" class="add-to-calendar-link">
								<app-icon [icon]="faCalendarIcon"/>
								Add to Google Calendar
							</a>

							@if (transactionResponse()!.submitted) {
								<img class="img cipc-logo" src="assets/img/computer-tick.png" alt="CIPC"/>
							}
						</div>

						<div class="modal-footer">
							<app-submit-button [submitLabel]="'Close'" (click)="modalService.hide()"></app-submit-button>
						</div>
					}
				</app-step>
			</app-stepper>
		</app-component-loader>
	</div>
</div>
